import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Loading from "../helpers/loading_component.js";
import "../styles/payments.css";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const AddNewTransactions = (props) => {
  const [file, setFile] = useState("");
  const [loading, setLoading] = useState(true);
  const [transactionsData, setTransactionsData] = useState([]);
  const [payments, setPayments] = useState([]);
  const [transactionsNaData, setTransactionsNaData] = useState([]);

  const fileReader = new FileReader();
  var array = [];
  var trToAdd = [];
  var arrayNa = [];

  const fetchTransactionsAss = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTransactionsAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTransactionsData(
          data.sort(function (a, b) {
            return new Date(b.assign_date) - new Date(a.assign_date);
          })
        );
      })
      .catch((error) => {});
  };

  const fetchTransactionsNAss = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTransactionsNotAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTransactionsNaData(
          data.sort(function (a, b) {
            return new Date(b.assign_date) - new Date(a.assign_date);
          })
        );
        fetchPayments();
      })
      .catch((error) => {});
  };

  const fetchPayments = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setPayments(data.filter((el) => !el.archive_date));
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchTransactionsAss();
    fetchTransactionsNAss();
  };

  useEffect(() => {
    getData();
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const readFile = (e) => {
    if (file) {
      e.preventDefault();
      setLoading(true);

      if (file) {
        fileReader.onload = function (event) {
          const text = event.target.result;
          csvFileToArray(text);
        };

        fileReader.readAsText(file, "Windows-1250");
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const csvFileToArray = (string) => {
    const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");
    const array1 = [];
    csvRows.map((i) => {
      const values = i.split(";");

      var length = 1;
      if (values[0] !== "" && values[15] !== "") {
        length = 16;
      } else if (values[0] !== "" && values[20] !== "") {
        length = 21;
      } else if (values[0] !== "" && values[10] !== "") {
        length = 11;
      }

      try {
        if (values.length === 21) {
          if (isValidDate(values[0])) {
            var data = {
              transactionDate: values[0],
              postingDate: values[1],
              transactionClient: values[2].replaceAll(/["',.]/g, ""),
              transactionTitle: values[3].replaceAll(/["',.]/g, ""),
              accountNumber: values[4]
                .replace(" ", "")
                .replace("'", "")
                .replace("PL", "")
                .replace("'", ""),
              bankName: values[5].replaceAll(/["',.]/g, ""),
              transactionNumber: values[7]
                .replace(" ", "")
                .replace("'", "")
                .replace("PL", "")
                .replace("'", ""),
              transactionValue: values[8],
              transactionCurrency: values[9],
            };
            array1.push(data);
          }
        } else if (values.length === 11) {
          var data = {
            transactionDate: values[0],
            postingDate: values[1],
            transactionClient: values[2].replaceAll(/["',.]/g, ""),
            transactionTitle: values[6].replaceAll(/["',.]/g, ""),
            accountNumber: values[4]
              .replace(" ", "")
              .replace("'", "")
              .replace("PL", "")
              .replace("'", ""),
            bankName: "",
            transactionNumber: values[9]
              .replace(" ", "")
              .replace("'", "")
              .replace("PL", "")
              .replace("'", ""),
            transactionValue: values[7],
            transactionCurrency: values[8],
          };
          array1.push(data);
        } else if (values.length === 16) {
          if (isValidDate(values[0])) {
            var data = {
              transactionDate: values[0],
              postingDate: values[1],
              transactionClient: values[2].replaceAll(/["',.]/g, ""),
              transactionTitle: values[3].replaceAll(/["',.]/g, ""),
              accountNumber: values[4]
                .replace(" ", "")
                .replace("'", "")
                .replace("PL", "")
                .replace("'", ""),
              bankName: values[5].replaceAll(/["',.]/g, ""),
              transactionNumber: values[7]
                .replace(" ", "")
                .replace("'", "")
                .replace("PL", "")
                .replace("'", ""),
              transactionValue: values[8],
              transactionCurrency: values[9],
            };
            array1.push(data);
          }
        } else if (values.length === 17 && values[16] === "PLN\r") {
          var data = {
            transactionDate: values[0],
            postingDate: values[1],
            transactionClient: values[2].replaceAll(/["',.]/g, ""),
            transactionTitle: values[3].replaceAll(/["',.]/g, ""),
            accountNumber: values[4]
              .replace(" ", "")
              .replace("'", "")
              .replace("PL", "")
              .replace("'", ""),
            bankName: values[5].replaceAll(/["',.]/g, ""),
            transactionNumber: values[7]
              .replace(" ", "")
              .replace("'", "")
              .replace("PL", "")
              .replace("'", ""),
            transactionValue: values[8],
            transactionCurrency: values[9],
          };
          array1.push(data);
        }
      } catch (err) {}
    });

    array = array1;

    checkTransactions();
  };

  const isValidDate = (date) => {
    var result = new Date(date);

    if (isNaN(result)) {
      return false;
    } else {
      return true;
    }
  };

  const checkIfDoubleName = (pEl) => {
    try {
      var data = payments.filter(
        (el) => el.name.replaceAll(",", "") === pEl.name.replaceAll(",", "")
      );
      var bool = true;
      if (data.length > 1) {
        bool = false;
      }
      return bool;
    } catch (err) {
      return true;
    }
  };

  const checkTransactions = async () => {
    try {
      payments.map((el) => {
        if (checkIfDoubleName(el)) {
          var tr = getTransactionsID(el);
          if (tr.length > 0) {
            trToAdd = trToAdd.concat(tr);
          }
        }
      });
      payments.map((el) => {
        if (checkIfDoubleName(el)) {
          var tr = getTransactionsName(el);
          if (tr.length > 0) {
            trToAdd = trToAdd.concat(tr);
          }
        }
      });
      trToAdd.map(async (el) => {
        var body = {
          date: el.date,
          client: el.client,
          title: el.title ? el.title : "",
          bank_acc: el.bank_acc,
          tr_id: el.tr_id,
          bank: el.bank,
          bill: el.bill,
          payId: el.payId,
          reason: el.reason,
          assign_date: el.assign_date,
          checked: el.checked,
          note: el.note,
        };

        await fetch(
          "https://apidevkppp.ftpeople.pl/insertTransactionsAssigned",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          }
        )
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
      });
      arrayNa = getNotAssigned();

      arrayNa.map(async (el) => {
        var body = {
          date: el.date,
          client: el.client,
          title: el.title ? el.title : "",
          bank_acc: el.bank_acc,
          tr_id: el.tr_id,
          bank: el.bank,
          bill: el.bill,
          payId: el.payId,
          reason: "",
          assign_date: el.assign_date,
          checked: el.checked,
          note: el.note,
        };

        await fetch(
          "https://apidevkppp.ftpeople.pl/insertTransactionsNotAssigned",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          }
        )
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
      });

      MySwal.fire({
        title: <strong>Dodano nowe transakcje</strong>,
        html:
          "<b>Podsumowanie</b><br>" +
          "Ilość transakcji: " +
          array.length +
          "<br>" +
          "Ilość przypisanych: " +
          trToAdd.length +
          "<br>" +
          "Ilość nieprzypisanych: " +
          arrayNa.length +
          "<br>" +
          "Pominięte duplikaty: " +
          (array.length - trToAdd.length - arrayNa.length),
        icon: "success",
      }).then((result) => {
        props.close();
      });
    } catch (err) {}

    return;

    var body = {};
    await fetch("https://apidevkppp.ftpeople.pl/getTransactionsAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        checkPayments(data);
      })
      .catch((error) => {});
  };

  const getNotAssigned = () => {
    var arrayNa = array;
    trToAdd.map((el) => {
      arrayNa = arrayNa.filter((el1) => el1.transactionNumber !== el.tr_id);
    });
    props.transactionsNaData.map((el3) => {
      arrayNa = arrayNa.filter((el4) => el4.transactionNumber !== el3.tr_id);
    });
    props.transactionsData.map((el5) => {
      arrayNa = arrayNa.filter((el6) => el6.transactionNumber !== el5.tr_id);
    });
    var arrToRet = [];
    arrayNa.map((el2) => {
      var data = {
        date: el2.transactionDate,
        client: el2.transactionClient,
        title: el2.transactionTitle ? el2.transactionTitle : "",
        bank_acc: el2.accountNumber,
        tr_id: el2.transactionNumber,
        bank: el2.bankName,
        bill: el2.transactionValue,
        payId: "",
        assign_date: new Date(),
        checked: "0",
        note: "",
      };
      arrToRet.push(data);
    });

    return arrToRet;
  };

  const checkExpectedTransactionsCount = (
    dateOfStartPayment,
    installmentCount
  ) => {
    var now = new Date();
    var startDate = new Date(dateOfStartPayment);
    var months = (now.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += now.getMonth();
    return months <= 0
      ? 0
      : months > installmentCount
      ? installmentCount
      : months;
  };

  const checkPayments = async (transactions) => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data
          .filter((el) => !el.archive_date)
          .map(async (el) => {
            var transactionsForPayment = transactions.filter(
              (tr) => tr.payId === el.identifier
            );
            transactionsForPayment.sort(function (a, b) {
              return new Date(b.date) - new Date(a.date);
            });
            var pay_sum = 0;
            for (var i = 0; i < transactionsForPayment.length; i += 1) {
              pay_sum =
                parseFloat(
                  transactionsForPayment[i].bill.replaceAll(",", ".")
                ) + pay_sum;
            }

            var archive =
              parseInt(el.to_settlement) === parseInt(pay_sum) ? "TAK" : "NIE";
            var bankAcc = el.bank_acc;
            if (transactionsForPayment.length > 0) {
              if (
                !transactionsForPayment[0].title.includes("Wpłata w UP") &&
                !transactionsForPayment[0].client.includes("CINKCIARZ")
              ) {
                bankAcc = transactionsForPayment[0].bank_acc;
              }
            }

            var body2 = {
              identifier: el.identifier,
              pay_sum: pay_sum,
              bank_acc: bankAcc,
              pay_count: transactionsForPayment.length,
              pay_expected_count: checkExpectedTransactionsCount(
                el.first_payment_date,
                el.installment
              ),
              last_pay_date:
                transactionsForPayment.length > 0
                  ? transactionsForPayment[0].date
                  : "",
              is_overdated:
                checkExpectedTransactionsCount(
                  el.first_payment_date,
                  el.installment
                ) > transactionsForPayment.length
                  ? "TAK"
                  : "NIE",
              to_archive:
                parseInt(el.to_settlement.toString().replace(",", ".")) ===
                parseInt(pay_sum.toString().replace(",", "."))
                  ? "TAK"
                  : "NIE",
              delay_time:
                archive === "TAK"
                  ? 0
                  : getDelayTime(
                      el.first_payment_date,
                      transactionsForPayment.length,
                      checkExpectedTransactionsCount(
                        el.first_payment_date,
                        el.installment
                      )
                    ),
            };

            await fetch("https://apidevkppp.ftpeople.pl/editPaymentCheck", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body2),
            })
              .then((response) => response.json())
              .then((data) => {})
              .catch((error) => {});
          });
      })
      .catch((error) => {});

    MySwal.fire({
      title: <strong>Dodano nowe transakcje</strong>,
      html:
        "<b>Podsumowanie</b><br>" +
        "Ilość transakcji: " +
        array.length +
        "<br>" +
        "Ilość przypisanych: " +
        trToAdd.length +
        "<br>" +
        "Ilość nieprzypisanych: " +
        arrayNa.length +
        "<br>" +
        "Pominięte duplikaty: " +
        (array.length - trToAdd.length - arrayNa.length),
      icon: "success",
    }).then((result) => {
      props.close();
    });
  };

  const days = (date_1, date_2) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return TotalDays;
  };

  const getDelayTime = (dateOfStartPayment, pay_sum, expected_pay_count) => {
    var startDate = new Date(dateOfStartPayment);
    var now = new Date();
    var lastPaymentDateForDelay = new Date(
      startDate.setMonth(startDate.getMonth() + pay_sum)
    );
    var delay_days = days(now, lastPaymentDateForDelay);
    return delay_days < 0 ? 0 : delay_days;
  };

  const getTransactionsID = (pEl) => {
    try {
      var trToReturn = [];
      array.map((el) => {
        var exist = checkIfTransactionExist(el);
        var value = checkValue(el, pEl, trToReturn);
        if (checkTransactionIdentifier(el, pEl.identifier) && !exist) {
          if (!value) {
            var data = {
              date: el.transactionDate,
              client: el.transactionClient,
              title: el.transactionTitle ? el.transactionTitle : "",
              bank_acc: el.accountNumber,
              tr_id: el.transactionNumber,
              bank: el.bankName,
              bill: el.transactionValue,
              payId: pEl.identifier,
              reason: "identyfikator",
              assign_date: new Date(),
              checked: "0",
              note: "",
            };
            trToReturn.push(data);
          }
        }
      });
      return trToReturn;
    } catch (err) {
      return null;
    }
  };

  const getTransactionsName = (pEl) => {
    try {
      var trToReturn = [];
      array.map((el) => {
        if (
          !el.transactionTitle.includes("Wpłata w UP") &&
          !el.transactionClient.includes("CINKCIARZ") &&
          !el.transactionTitle.includes("Revolut")
        ) {
          var name = checkName(el.transactionClient, pEl.name);
          var bank = false;
          if (!pEl.identifier.toString().toLowerCase().includes("kzp")) {
            bank = checkBankAcc(el.accountNumber, pEl.bank_acc);
          }
          var title = checkTitle(el.transactionTitle, pEl.name);
          var exist = checkIfTransactionExist(el);
          var value = checkValue(el, pEl, trToReturn);
          if ((name || title || bank) && !exist) {
            if (!value) {
              var data = {
                date: el.transactionDate,
                client: el.transactionClient,
                title: el.transactionTitle ? el.transactionTitle : "",
                bank_acc: el.accountNumber,
                tr_id: el.transactionNumber,
                bank: el.bankName,
                bill: el.transactionValue,
                payId: pEl.identifier,
                reason: bank
                  ? "numer konta bankowego"
                  : name
                  ? "nazwa nadawcy"
                  : title
                  ? "tytuł przelewu"
                  : "",
                assign_date: new Date(),
                checked: "0",
                note: "",
              };
              trToReturn.push(data);
            }
          }
        }
      });
      return trToReturn;
    } catch (err) {
      return null;
    }
  };

  const checkTitle = (titleTr, nameP) => {
    var set1 = nameP.split(" ");
    var set2 = titleTr.split(" ");

    var bool = false;
    var matchName = false;
    var matchSurname = false;
    for (var i = 0; i < set1.length; i = i + 2) {
      for (var k = 0; k < set2.length; k++) {
        if (
          set1[i].toString().replaceAll(",", "").toLowerCase() ===
          set2[k]
            .toString()
            .replaceAll(",", "")
            .replaceAll(".", "")
            .toLowerCase()
        ) {
          matchName = true;
        }
      }
    }
    for (var o = 1; o < set1.length; o = o + 2) {
      for (var m = 0; m < set2.length; m++) {
        if (
          set1[o].toString().replaceAll(",", "").toLowerCase() ===
          set2[m]
            .toString()
            .replaceAll(",", "")
            .replaceAll(".", "")
            .toLowerCase()
        ) {
          matchSurname = true;
        }
      }
    }
    if (matchName && matchSurname) {
      bool = true;
    } else {
      bool = false;
    }
    return bool;
  };

  const checkNamePayments = (nameP) => {
    var check = payments.filter((el) => el.name === nameP);
    if (check.length > 1) {
      return true;
    } else {
      return false;
    }
  };

  const checkName = (nameTr, nameP) => {
    var set1 = nameP.split(" ");
    var set2 = nameTr.split(" ");

    var bool = false;
    var matchName = false;
    var matchSurname = false;
    for (var i = 0; i < set1.length; i = i + 2) {
      for (var k = 0; k < set2.length; k++) {
        if (
          set1[i].toString().replaceAll(",", "").toLowerCase() ===
          set2[k].toString().replaceAll(",", "").toLowerCase()
        ) {
          matchName = true;
        }
      }
    }
    for (var o = 1; o < set1.length; o = o + 2) {
      for (var m = 0; m < set2.length; m++) {
        if (
          set1[o].toString().replaceAll(",", "").toLowerCase() ===
          set2[m].toString().replaceAll(",", "").toLowerCase()
        ) {
          matchSurname = true;
        }
      }
    }
    if (matchName && matchSurname && !checkNamePayments(nameP)) {
      bool = true;
    } else {
      bool = false;
    }
    return bool;
  };

  const checkBankAcc = (bankTr, bankP) => {
    var bool = false;

    if (bankTr === bankP) {
      bool = true;
    } else {
      bool = false;
    }
    return bool;
  };

  const checkTransactionIdentifier = (tr, id) => {
    var setTr = tr.transactionTitle.toString().split(" ");
    var bool = false;
    setTr.map((el1) => {
      if (
        el1.toString().replaceAll(",", "").replaceAll(".", "").toLowerCase() ===
          id.toString().toLowerCase() &&
        !checkIfTransactionExist(tr)
      ) {
        bool = true;
      }
    });
    return bool;
  };

  const checkValue = (trEl, pEl, trToReturn) => {
    var pay_sum = pEl.pay_sum === undefined ? 0 : +pEl.pay_sum;
    for (var i = 0; i < trToAdd.length; i += 1) {
      if (trToAdd[i].id === pEl.identifier) {
        pay_sum = parseInt(trToAdd[i].bill) + pay_sum;
      }
    }
    for (var k = 0; k < trToReturn.length; k += 1) {
      pay_sum = +trToReturn[k].bill.replaceAll(",", ".") + pay_sum;
    }
    pay_sum = pay_sum + +trEl.transactionValue.replaceAll(",", ".");
    var bool = true;

    if (+pay_sum > +pEl.to_settlement) {
      bool = true;
    } else {
      bool = false;
    }
    return bool;
  };

  const checkIfTransactionExist = (trEl) => {
    var check = transactionsData.filter(
      (el) => el.tr_id === trEl.transactionNumber
    );
    var check2 = trToAdd.filter((el) => el.tr_id === trEl.transactionNumber);
    var check3 = transactionsNaData.filter(
      (el) => el.tr_id === trEl.transactionNumber
    );
    if (check.length > 0 || check2.length > 0 || check3.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (array.length > 0 && loading) {
        setLoading(false);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="mainContainerAddTransaction">
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>

            <div id="addPaymentIC" className="inputContainer">
              <div className="inputBox">
                <div className="inputCol_1">
                  <input
                    className="fileInputAP"
                    type="file"
                    onChange={handleFileChange}
                  />
                </div>
              </div>
              <div className="saveBoxAP">
                <button className="paymentMenuButton" onClick={readFile}>
                  wczytaj
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddNewTransactions;
